import { type FC } from 'react';
import { useDispatch } from 'react-redux';

import { acceptIncomingChange } from '@editor2/reducers/editor/editorSlice';
import { type Conflict, type ReorderConflict } from '@editor2/types/conflict';
import AcceptButton from './AcceptButton';
import IncomingChangesAuthors from './IncomingChangesAuthors';

interface Props {
	courseId: number;
	conflict: Conflict | ReorderConflict;
	showButton: boolean;
}

const IncomingChangesDivider: FC<Props> = (props) => {
	const { courseId, conflict, showButton } = props;

	const dispatch = useDispatch();

	const keepTheirChangesTooltip =
		'Retain the incoming conflicting change, throwing away your change';

	const onAcceptIncomingClick = () => {
		dispatch(acceptIncomingChange({ courseId, conflict }));
	};

	return (
		<div className="changesDivider">
			<span className="divider-text">
				<span>{`[ Others' change ] - made by `}</span>
				<IncomingChangesAuthors courseId={courseId} />
			</span>

			{showButton && (
				<AcceptButton
					name="Keep their changes"
					variant="outline-warning"
					tooltip={keepTheirChangesTooltip}
					onAcceptClick={() => onAcceptIncomingClick()}
				/>
			)}
		</div>
	);
};

export default IncomingChangesDivider;
